import { Col, Row } from '@/app/components/Flex/Flex'
import { Link } from '@/app/components/Link/Link'
import { Text } from '@/app/components/Text/Text'
import { UI } from '@/app/components/UI/UI'
import PlusSvg from '@/app/icons/plus.svg?react'
import classNames from 'classnames'
import type { FunctionalComponent } from 'preact'
import { useState } from 'preact/hooks'
import styles from './index.module.scss'

export const FaqItem: FunctionalComponent<{
  question: string
  answer: string
  link?: {
    href: string
    text: string
  }
}> = props => {
  const [active, setActive] = useState(false)

  return (
    <div
      class={classNames(styles.item, {
        [styles.active]: active,
      })}
    >
      <button
        class={classNames(styles.head, {
          [styles.active]: active,
        })}
        onClick={() => {
          setActive(!active)
        }}
      >
        <UI.Panel type='ghost'>
          <Col
            gap={15}
            justifyContent='space-between'
            alignItems='center'
          >
            <Text
              as='h2'
              fontSize={16}
              fontWeight={600}
            >
              {props.question}
            </Text>

            <PlusSvg
              width={24}
              height={24}
              strokeWidth={1.2}
            />
          </Col>
        </UI.Panel>
      </button>

      <div class={styles.body}>
        <UI.Panel
          type='ghost'
          class={styles.bodyInner}
        >
          <Row gap={10}>
            <Text
              as='p'
              fontSize={16}
            >
              {props.answer}
            </Text>

            {props.link && (
              <Text
                as='p'
                fontSize={16}
                fontWeight={500}
              >
                <Link class='thin-link' to={`~${props.link.href}`}>
                  {props.link.text}
                </Link>
              </Text>
            )}
          </Row>
        </UI.Panel>
      </div>
    </div>
  )
}
